import { render } from "./CartPrice.vue?vue&type=template&id=f618b99a&scoped=true"
import script from "./CartPrice.vue?vue&type=script&lang=js"
export * from "./CartPrice.vue?vue&type=script&lang=js"

import "./CartPrice.vue?vue&type=style&index=0&id=f618b99a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f618b99a"]])

export default __exports__